export default "__VITE_ASSET__pBP6PdF0__"